import { useState, useEffect } from 'react'

// eslint-disable-next-line import/prefer-default-export
export function useDidMount() {
  const [didMount, setDidMount] = useState(false)
  useEffect(() => {
    setDidMount(true)
  }, [])
  return didMount
}
